import { render } from "./showSingleTextfile.vue?vue&type=template&id=b6e90ef0&scoped=true"
import script from "./showSingleTextfile.vue?vue&type=script&lang=js"
export * from "./showSingleTextfile.vue?vue&type=script&lang=js"

import "./showSingleTextfile.vue?vue&type=style&index=0&id=b6e90ef0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EZZKAH\\IdeaProjects\\datapark\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6e90ef0"]])

export default __exports__